<!--
  导入ecxel
  jay 2020-01-02
 -->
<template>
  <Modal
    :value="excelFlag"
    :title="$t('common.importSample')"
    class-name="vertical-center-modal"
    width="490"
    @on-cancel="closePop"
  >
    <div class="modal-container">
      <p>{{ $t("recharge.importExcelBatchRechargeTips") }}</p>
      <p>
        <export-excel
          fileName="example"
          :tHeader="exportHeader"
          :filterVal="exportFilterVal"
          :exportList="exportExcelData"
          :btnText="$t('common.downloadTemplate')"
        />
      </p>
      <img src="@/assets/images/public/excel.png" />
    </div>
    <div slot="footer" class="footer" align="center">
      <import-excel
        :importExcelFlag.sync="importExcelFlag"
        :importExcelModel="importExcelModel"
        @getImportData="getImportData"
      />
    </div>
  </Modal>
</template>

<script>
import ImportExcel from "@/components/excel/import";
import ExportExcel from "@/components/excel/export";
export default {
  props: {
    excelFlag: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ImportExcel,
    ExportExcel
  },
  data() {
    return {
      importExcelFlag: false,
      importExcelModel: [
        { label: this.$t("common.mobileNumber"), value: "phone" }
      ]
    };
  },
  created() {
    this._getExportExcelData();
  },
  mounted() {},
  computed: {},
  methods: {
    closePop() {
      this.$emit("update:excelFlag", false);
    },
    _getExportExcelData() {
      //导出excel
      let vm = this;
      let tHeader = [this.$t("common.mobileNumber")];
      let filterVal = ["phone"];
      let list = [];
      for (let i = 0; i < 10; i++) {
        let obj = {};
        obj.phone = 9271111111 + i;
        obj.phone = "0" + Number(obj.phone);
        list.push(obj);
      }
      vm.exportHeader = tHeader;
      vm.exportFilterVal = filterVal;
      vm.exportExcelData = list;
    },
    getImportData(data) {
      // 获取导入数据
      console.log("getImportData", data);
      let vm = this;
      vm.importExcelFlag = false;
      if (data.length > 1000) {
        vm.$Modal.error({
          content: vm.$t("recharge.importUpperLimitTips"),
          onOk: function() {
            vm.$emit("update:excelFlag", false);
          }
        });
        return false;
      }
      let list = [];
      let flag = true;
      for (let key of data) {
        let phone = (key.phone + "").replace(/\s/g, "");
        if (/[^\d\n\s;]/g.test(phone)) {
          //验证文本格式，是否包含数字、换行、空格、分号
          flag = false;
        }
        list.push(phone);
      }
      console.log("getImportData.list", list);
      if (!flag) {
        vm.$Modal.error({
          content: vm.$t("recharge.importExcelDataFormatTips"),
          onOk: function() {
            vm.$emit("update:excelFlag", false);
          }
        });
        return false;
      }
      if (list.length) {
        // console.log(arr)
        vm.$emit("getExcelData", list);
      }
    }
  },
  watch: {},
  beforeDestroy() {}
};
</script>
<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.modal-container {
  p {
    font-size: 14px;
    color: #4a4a4a;
    line-height: 28px;
    // margin-bottom: 20px;
    &.link-a {
      a {
      }
    }
  }
}
</style>
